import { cloneDeep } from 'lodash'

export function handleFalsyToParams(params) {
  if (!params) return {}
  const hostParams = cloneDeep(params)
  const falsy = ['', undefined, null]
  Object.entries(hostParams).forEach(([key, value]) => {
    if (falsy.includes(value)) {
      Reflect.deleteProperty(hostParams, key)
    }
  })
  return hostParams
}
